import {BoardService} from './board.service';

export const BoardInjectables: Array<any> = [
  {
    provide: BoardService,
    useClass: BoardService,
  },
];
